import React from 'react';
import './Contact.css';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import ContactForm from "../components/ContactForm"; 


const ContactUs = () => {
  return (
    <div className="contact-container">
      <h1 className="contact-header">Reach Out to Us</h1>
      
      <div className="contact-content">
        {/* Left side: Icon info boxes */}
        <div className="contact-info-grid">
          <div className="info-box">
            <div className="icon-circle phone-icon">
              
            </div>
            <div>
              <h4>Phone</h4>
              <p>+91 79055 13982</p> 
              <p>+91 88401 55356</p>
            </div>
          </div>

          <div className="info-box">
            <div className="icon-circle email-icon">
              
            </div>
            <div>
              <h4>Email</h4>
              <p>jyotishkarmaa@gmail.com</p>
            </div>
          </div>

          <div className="info-box">
            <div className="icon-circle address-icon">
              
            </div>
            <div>
              <h4>Address</h4>
              <p>Lucknow , Uttar Pradesh</p>
            </div>
          </div>

          <div className="info-box">
            <div className="icon-circle clock-icon">
              
            </div>
            <div>
              <h4>Working Hours</h4>
              <p>Mon - Sat: 9am - 7pm</p>
            </div>
          </div>
        </div>

        {/* Right side: Contact form */}
          <ContactForm />
      </div>

      {/* Google Map */}
      <div className="map-container">
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3558.403788915488!2d80.9462!3d26.8467!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfd9911f5b5bb%3A0x8a7d9d9b5b8f6c1a!2sLucknow%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1717000000000"
          width="100%"
          height="300"
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
};

export default ContactUs;
